export type DocStatus =
  'UPLOADING' |
  'FILED' |
  'UNFILED' |
  'DELETED';

export const DocStatuses = {
  UPLOADING: 'UPLOADING' as DocStatus,
  FILED: 'FILED' as DocStatus,
  UNFILED: 'UNFILED' as DocStatus,
  DELETED: 'DELETED' as DocStatus,

  parse(code: string): DocStatus {
    if (!code || typeof code !== 'string' || code.toUpperCase() !== code || !(code in DocStatuses)) {
      throw new Error(`Invalid doc status ${code}`) ;
    }

    return DocStatuses[code];
  },

  all(): DocStatus[] {
    return Object.keys(DocStatuses)
      .filter(key => typeof DocStatuses[key] === 'string')
      .map(key => DocStatuses[key]);
  },

  filterable(): DocStatus[] {
    return DocStatuses.all()
      .filter(status => status !== DocStatuses.UPLOADING)
      .map(key => DocStatuses[key]);
  },

  default(): DocStatus[] {
    return [DocStatuses.UNFILED, DocStatuses.FILED];
  }
};



// WEBPACK FOOTER //
// ./src/common/models/DocStatus.ts